export default "__VITE_ASSET__jEA2Dr43__"